const BILL_APPROVING = 'Approving';

export { BILL_APPROVING };